/**
 * 封装的全局指令
 * */
import vue from 'vue'
// 自动聚焦。验证码控件有在部分地方不需要聚焦。所以给指令增加一个参数 v-focus=true or v-focus=1 只需要将值转换为boolean为true即不会聚焦
vue.directive('focus', {
  inserted (el, { value }) {
    if (!value) {
      // 如果是文本框 直接聚焦，如果是 el-input 需要找到他的 input 然后再聚焦
      el instanceof HTMLInputElement ? el.focus() : el.querySelector('input').focus()
    }
  }
})



// WEBPACK FOOTER //
// ./src/directives/index.js